var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',[_c('div',{staticStyle:{"display":"none"},attrs:{"id":"toolbar"}}),_c('div',{staticStyle:{"padding":"5px 0","color":"#ccc"}}),_c('div',{staticStyle:{"box-shadow":"0 2px 12px 0 rgba(0, 0, 0, 0.1)","height":"400px"},attrs:{"id":"wangEditor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }